
import React from "react";
import * as Styled from "./Button.styles";

export const Button = ({properties, ...rest}) => {
    console.log(properties);
    return (<Styled.Button {...rest} variant="contained" color="primary">{properties.label}</Styled.Button>);
}